function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.regexp.flags.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.date.to-iso-string.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { createContext, useRef, useState } from 'react';
import { match } from 'ts-pattern';
import { isBefore, sub } from 'date-fns';
import { flushSync } from 'react-dom';
import { useParams } from 'react-router-dom';
import { TimelessDateStringInput } from "../../../../../components/TimelessDateStringInput";
import { canUploadFiles, canAnswerQuestions, RejectionMessage } from "../../../../../components/DynamicForm";
import { RequirementCard } from "../../../../../components/RequirementCard";
import { useApplicationPagePermissions, useFeatureFlags, useUpdateApplicationRequirement } from "../../../data";
import { copyToClipboard, useTranslation } from '@applyboard/ui-utils';
import { Button, ButtonLink, createForm, Dialog, Flex, MenuButton, Text, useId, useToasts } from '@applyboard/crystal-ui';
import { CalendarDateEndOutlineIcon, CopyOutlineIcon, EditOutlineIcon, FullscreenOutlineIcon, MoreVertOutlineIcon, NoStatusOutlineIcon, ToggleOutlineIcon } from '@applyboard/ui-icons';
import { ProvideAnswersButton } from "./ProvideAnswersButton";
import { UpdateRequirementDialog } from "./UpdateRequirementDialog";
import { getAnswersCount, getAmount, getLatestAttachments } from "./ApplicationRequirementCard.utils";
import { useContextOrThrow } from "../../../../../utils/hooks";
import { useApplicationId } from "../../../data/aggregatedData";
import { canPerformAction, canUpdateReqAttribute } from "../../../../../utils/actions";
import { assert } from "../../../../../utils/assert";
import { useRequirementListEventTracker } from "../../../utils/eventTracking";
import { useSidebar } from "../../SideBar";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
var ApplicationRequirementCardContext = /*#__PURE__*/createContext(null);
export function ApplicationRequirementCard(_ref) {
  var requirement = _ref.requirement,
    selected = _ref.selected,
    hideActions = _ref.hideActions,
    expandButtonRef = _ref.expandButtonRef,
    onOpenChange = _ref.onOpenChange,
    headingLevel = _ref.headingLevel,
    onSubmissionSuccess = _ref.onSubmissionSuccess,
    collapseButtonRef = _ref.collapseButtonRef;
  var _useParams = useParams(),
    appId = _useParams.application_id;
  var amount = getAmount(requirement);
  var _useFeatureFlags = useFeatureFlags(),
    featureFlags = _useFeatureFlags.featureFlags;
  var _useApplicationPagePe = useApplicationPagePermissions(),
    permissions = _useApplicationPagePe.permissions;
  var _useRequirementListEv = useRequirementListEventTracker(),
    trackEvent = _useRequirementListEv.trackEvent;
  var requirementWithModifiedFlags = _objectSpread(_objectSpread({}, requirement), {}, {
    flags: _objectSpread(_objectSpread({}, requirement.flags), {}, {
      applyboardRequirement: featureFlags['application_apr_admin_features'] ? requirement.flags['applyboardRequirement'] : false,
      manual: featureFlags['application_apr_admin_features'] && requirement.flags['manual'],
      modified: featureFlags['application_apr_admin_features'] && requirement.flags['modified']
    })
  });
  var responseCount = getResponseCount({
    requirement: requirement,
    permissions: permissions
  });
  return _jsx(ApplicationRequirementCardContext.Provider, {
    value: {
      appId: appId,
      expandButtonRef: expandButtonRef,
      hideActions: hideActions,
      onOpenChange: onOpenChange,
      collapseButtonRef: collapseButtonRef
    },
    children: _jsx(RequirementCard, {
      message: !selected && _jsx(RequirementMessage, {
        requirement: requirement
      }),
      requirement: requirementWithModifiedFlags,
      featureFlags: featureFlags,
      selected: selected,
      isCompactLayout: hideActions,
      numAttachmentsUploaded: responseCount.attachmentCount,
      numQuestionsAnswered: responseCount.answerCount,
      amount: amount,
      Actions: ApplicationRequirementCardActions,
      href: hideActions && !selected ? "/applications/".concat(appId, "/requirements/").concat(requirement.id) : undefined,
      headingLevel: headingLevel,
      onSubmissionSuccess: onSubmissionSuccess,
      onEvent: function onEvent(event) {
        if (event === 'applicant_tab_selected') {
          trackEvent({
            event: 'Clicked applicant view',
            data: {
              requirementTemplateReferenceNumber: requirement.requirementTemplateNumber
            }
          });
        }
      }
    })
  });
}
function ApplicationRequirementCardActions(_ref2) {
  var requirement = _ref2.requirement,
    onSubmissionSuccess = _ref2.onSubmissionSuccess;
  var _useTranslation = useTranslation('ApplicationRequirementCard'),
    t = _useTranslation.t;
  var _useFeatureFlags2 = useFeatureFlags(),
    featureFlags = _useFeatureFlags2.featureFlags;
  var _useRequirementListEv2 = useRequirementListEventTracker(),
    trackEvent = _useRequirementListEv2.trackEvent;
  var _useContextOrThrow = useContextOrThrow(ApplicationRequirementCardContext),
    appId = _useContextOrThrow.appId,
    expandButtonRef = _useContextOrThrow.expandButtonRef,
    hideActions = _useContextOrThrow.hideActions,
    onOpenChange = _useContextOrThrow.onOpenChange,
    collapseButtonRef = _useContextOrThrow.collapseButtonRef;
  var isAdminRequirement = requirement.classification !== 'applicant_requirement';
  var classificationSlug = isAdminRequirement ? 'admin-requirements' : 'requirements';
  var canFulfill = isAdminRequirement ? canPerformAction(requirement, 'approve') : canPerformAction(requirement, 'submit');
  var canEditDeadline = canUpdateReqAttribute(requirement, 'deadline');
  var canEvaluate = !isAdminRequirement && featureFlags['application_apr_admin_features'] && (canPerformAction(requirement, 'reject') || canPerformAction(requirement, 'approve'));
  var _useSidebar = useSidebar(),
    setIsSidebarOpen = _useSidebar.setIsSidebarOpen;
  return _jsxs(Flex, {
    direction: {
      xs: 'column',
      sm: 'row'
    },
    grow: 1,
    justify: "end",
    gap: 2,
    children: [!hideActions && requirement.status !== 'inactive' && canFulfill && _jsx(ProvideAnswersButton, {
      requirementId: requirement.id,
      onOpenChange: onOpenChange,
      onSubmissionSuccess: onSubmissionSuccess
    }), !hideActions && _jsxs(Flex, {
      gap: 2,
      justify: "end",
      children: [_jsx(ButtonLink, {
        emphasis: canEvaluate && requirement.status === 'reviewing' ? 'contained' : 'outlined',
        href: "/applications/".concat(appId, "/").concat(classificationSlug, "/").concat(requirement.id),
        intent: "primary",
        leadIcon: FullscreenOutlineIcon,
        ref: expandButtonRef,
        width: {
          xs: 'fill',
          md: 'hug'
        },
        onAfterHistoryPush: function onAfterHistoryPush() {
          var _collapseButtonRef$cu;
          trackEvent({
            event: canEvaluate ? 'Clicked open requirement in review mode' : 'Clicked details',
            data: {
              requirementTemplateReferenceNumber: requirement.requirementTemplateNumber
            }
          });
          collapseButtonRef === null || collapseButtonRef === void 0 ? void 0 : (_collapseButtonRef$cu = collapseButtonRef.current) === null || _collapseButtonRef$cu === void 0 ? void 0 : _collapseButtonRef$cu.focus();
          setIsSidebarOpen(false);
        },
        children: canEvaluate ? t('review') : t('details')
      }), !hideActions && _jsxs(Flex, {
        grow: 1,
        gap: 2,
        children: [featureFlags['application_apr_admin_features'] && requirement.status !== 'approved' && canEditDeadline && _jsx(SetDueDateButton, {
          requirement: requirement
        }), _jsx(MoreActionsMenu, {
          requirement: requirement
        })]
      })]
    })]
  });
}
function getResponseCount(_ref3) {
  var requirement = _ref3.requirement,
    permissions = _ref3.permissions;
  var userCanAnswerQuestions = canAnswerQuestions(requirement.formDefinition);
  var userCanUploadFiles = canUploadFiles(requirement.formDefinition);
  if (requirement.status === 'missing' && !permissions.fulfil_requirement) {
    return {
      answerCount: userCanAnswerQuestions ? 0 : undefined,
      attachmentCount: userCanUploadFiles ? 0 : undefined
    };
  }
  var attachments = getLatestAttachments(requirement);
  var _getAnswersCount = getAnswersCount(requirement),
    answersCount = _getAnswersCount.answersCount;
  return {
    answerCount: userCanAnswerQuestions ? answersCount : undefined,
    attachmentCount: userCanUploadFiles ? attachments.length : undefined
  };
}
function RequirementMessage(_ref4) {
  var _responses$answersHis, _responses$answersHis2, _responses$answersHis3, _responses$answersHis4;
  var requirement = _ref4.requirement;
  var formDefinition = requirement.formDefinition,
    responses = requirement.responses;
  var _useTranslation2 = useTranslation('ApplicationRequirementCard'),
    t = _useTranslation2.t;
  var numRejectedQuestions = (responses === null || responses === void 0 ? void 0 : (_responses$answersHis = responses.answersHistory) === null || _responses$answersHis === void 0 ? void 0 : (_responses$answersHis2 = _responses$answersHis[0]) === null || _responses$answersHis2 === void 0 ? void 0 : _responses$answersHis2.answers.filter(function (answer) {
    var component = formDefinition.components.find(function (component) {
      return component.key === answer.key;
    });
    assert(component, "Component with key ".concat(answer.key, " not found in formDefinition"));
    return component.type !== 'file' && answer.decisions.some(function (decision) {
      return decision.status === 'rejected' && decision.type === 'overall';
    });
  }).length) || 0;
  var numRejectedFiles = (responses === null || responses === void 0 ? void 0 : (_responses$answersHis3 = responses.answersHistory) === null || _responses$answersHis3 === void 0 ? void 0 : (_responses$answersHis4 = _responses$answersHis3[0]) === null || _responses$answersHis4 === void 0 ? void 0 : _responses$answersHis4.answers.reduce(function (count, answer) {
    var component = formDefinition.components.find(function (component) {
      return component.key === answer.key;
    });
    assert(component, "Component with key ".concat(answer.key, " not found in formDefinition"));
    if (component.type !== 'file') {
      return count;
    }
    var numRejectedFilesForComponent = answer.decisions.filter(function (decision) {
      return decision.status === 'rejected' && decision.type === 'per_item';
    }).length;
    return count + numRejectedFilesForComponent;
  }, 0)) || 0;
  if (numRejectedQuestions > 0 && numRejectedFiles > 0) {
    return _jsx(RejectionMessage, {
      message: t('failedAnswersAndDocumentsMessage', {
        numRejectedQuestions: numRejectedQuestions,
        numRejectedFiles: numRejectedFiles
      })
    });
  }
  if (numRejectedQuestions > 0) {
    return _jsx(RejectionMessage, {
      message: t('failedAnswersMessage', {
        numRejectedQuestions: numRejectedQuestions
      })
    });
  }
  if (numRejectedFiles > 0) {
    return _jsx(RejectionMessage, {
      message: t('failedDocumentsMessage', {
        numRejectedFiles: numRejectedFiles
      })
    });
  }
  return null;
}
var _createForm = createForm(),
  Field = _createForm.Field,
  Form = _createForm.Form;
function SetDueDateButton(_ref5) {
  var requirement = _ref5.requirement;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useTranslation3 = useTranslation('ApplicationRequirementCard'),
    t = _useTranslation3.t;
  var formId = useId();
  var _useUpdateApplication = useUpdateApplicationRequirement(),
    setNextUpdate = _useUpdateApplication.setNextUpdate,
    updateStatus = _useUpdateApplication.updateStatus;
  var toasts = useToasts();
  var minDate = sub(new Date(), {
    days: 1
  });
  var maxDate = new Date(2099, 11, 31);
  var _useRequirementListEv3 = useRequirementListEventTracker(),
    trackEvent = _useRequirementListEv3.trackEvent;
  return _jsxs(Dialog, {
    open: isOpen,
    onOpenChange: function onOpenChange(isOpen) {
      setIsOpen(isOpen);
      trackEvent(_objectSpread({
        event: isOpen ? 'Clicked set requirement due date' : 'Set requirement due date - Dismissed set requirement due date'
      }, Boolean(isOpen) && {
        data: {
          requirementTemplateReferenceNumber: requirement.requirementTemplateNumber
        }
      }));
    },
    children: [_jsx(Dialog.Trigger, {
      children: _jsx(Button, {
        leadIcon: CalendarDateEndOutlineIcon,
        emphasis: "outlined",
        intent: "primary",
        "aria-label": t('setDueDate.title'),
        onClick: function onClick() {
          return setIsOpen(true);
        }
      })
    }), _jsx(Dialog.Heading, {
      children: t('setDueDate.title')
    }), _jsx(Dialog.Content, {
      children: _jsx(Form, {
        id: formId,
        defaultValues: {
          deadline: requirement.deadline || ''
        },
        onSubmit: function onSubmit(values) {
          setNextUpdate({
            id: requirement.id,
            type: requirement.type,
            deadline: values.deadline
          }, {
            onSuccess: function onSuccess() {
              toasts.positive(t('setDueDate.successMessage'));
              setIsOpen(false);
            },
            onError: function onError(error) {
              return toasts.negative(error);
            }
          });
        },
        children: _jsxs(Flex, {
          direction: "column",
          gap: 6,
          children: [_jsx(Text, {
            children: t('setDueDate.instructions', {
              requirementTitle: requirement.title
            })
          }), _jsx(Field, {
            as: TimelessDateStringInput,
            label: t('setDueDate.fieldLabel'),
            name: "deadline",
            required: t('setDueDate.requiredError'),
            minDate: minDate.toISOString(),
            maxDate: maxDate.toISOString(),
            validate: function validate(value) {
              return isBefore(new Date(value), minDate) ? t('setDueDate.dateInPastError') : true;
            }
          })]
        })
      })
    }), _jsxs(Dialog.Actions, {
      children: [_jsx(Dialog.CloseButton, {
        width: "fill",
        children: t('setDueDate.cancel')
      }), _jsx(Button, {
        type: "submit",
        form: formId,
        loading: updateStatus === 'loading',
        intent: "primary",
        width: "fill",
        onClick: function onClick() {
          return trackEvent({
            event: 'Set requirement due date - Clicked set due date'
          });
        },
        children: t('setDueDate.confirm')
      })]
    })]
  });
}
function MoreActionsMenu(_ref6) {
  var requirement = _ref6.requirement;
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedAction = _useState4[0],
    setSelectedAction = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isMenuOpen = _useState6[0],
    setIsMenuOpen = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isEditRequirementOpen = _useState8[0],
    setIsEditRequirementOpen = _useState8[1];
  var applicationId = useApplicationId();
  var toasts = useToasts();
  var _useTranslation4 = useTranslation('ApplicationRequirementCard'),
    t = _useTranslation4.t;
  var _useFeatureFlags3 = useFeatureFlags(),
    featureFlags = _useFeatureFlags3.featureFlags;
  var menuButtonRef = useRef(null);
  var showAdminFeatures = featureFlags['application_apr_admin_features'];
  var canUpdateOptional = canUpdateReqAttribute(requirement, 'flags.optional');
  var canUpdateActive = canUpdateReqAttribute(requirement, 'flags.active');
  var canUpdateRequirement = showAdminFeatures && requirement.status !== 'approved' && canUpdateReqAttribute(requirement, 'title');
  var _useRequirementListEv4 = useRequirementListEventTracker(),
    trackEvent = _useRequirementListEv4.trackEvent;
  return _jsxs(_Fragment, {
    children: [_jsxs(MenuButton, {
      alignment: "right",
      open: isMenuOpen,
      onOpenChange: function onOpenChange(isMenuOpen) {
        setIsMenuOpen(isMenuOpen);
        if (isMenuOpen) {
          trackEvent({
            event: 'Clicked requirements action menu'
          });
        }
      },
      menuWidth: "hug",
      children: [_jsx(MenuButton.Trigger, {
        children: _jsx(Button, {
          leadIcon: MoreVertOutlineIcon,
          emphasis: "outlined",
          intent: "primary",
          "aria-label": t('moreActionsMenu'),
          onClick: function onClick() {
            return setIsMenuOpen(true);
          },
          ref: menuButtonRef
        })
      }), canUpdateRequirement && _jsx(MenuButton.Button, {
        icon: EditOutlineIcon,
        id: "editRequirement-".concat(requirement.id),
        onClick: function onClick() {
          trackEvent({
            event: 'Requirements action menu - Clicked edit requirement'
          });
          setIsEditRequirementOpen(true);
          setIsMenuOpen(false);
        },
        children: t('editRequirement.button')
      }), _jsx(MenuButton.Button, {
        icon: CopyOutlineIcon,
        id: "copyRequirementLink-".concat(requirement.id),
        onClick: function onClick() {
          trackEvent({
            event: 'Requirements action menu - Clicked copy requirement link'
          });
          copyToClipboard("".concat(window.location.origin, "/applications/").concat(applicationId, "/requirements/").concat(requirement.id));
          toasts.positive(t('linkCopiedToClipboard'));
          setIsMenuOpen(false);
        },
        children: t('copyRequirementLink')
      }), showAdminFeatures && (canUpdateOptional || canUpdateActive) && _jsx(MenuButton.Divider, {}), showAdminFeatures && canUpdateOptional && _jsx(MenuButton.Button, {
        icon: ToggleOutlineIcon,
        id: "updateOptionalBtn-".concat(requirement.id),
        onClick: function onClick() {
          trackEvent({
            event: requirement.flags.optional ? 'Requirements action menu - Clicked make requirement required' : 'Requirements action menu - Clicked make requirement optional'
          });
          setSelectedAction('optional');
          setIsMenuOpen(false);
        },
        children: t(requirement.flags.optional ? 'makeRequired.button' : 'makeOptional.button')
      }), showAdminFeatures && canUpdateActive && _jsx(MenuButton.Button, {
        icon: NoStatusOutlineIcon,
        id: "updateActiveBtn-".concat(requirement.id),
        onClick: function onClick() {
          trackEvent({
            event: requirement.flags.active ? 'Requirements action menu - Clicked deactivate requirement' : 'Requirements action menu - Clicked activate requirement'
          });
          setSelectedAction('active');
          setIsMenuOpen(false);
        },
        children: t(requirement.flags.active ? 'deactivate.button' : 'activate.button')
      })]
    }), isEditRequirementOpen && _jsx(UpdateRequirementDialog, {
      isOpen: isEditRequirementOpen,
      onClose: function onClose() {
        var _menuButtonRef$curren;
        setIsEditRequirementOpen(false);
        (_menuButtonRef$curren = menuButtonRef.current) === null || _menuButtonRef$curren === void 0 ? void 0 : _menuButtonRef$curren.focus();
      },
      requirementId: requirement.id
    }), _jsx(MoreActionsConfirmationDialog, {
      menuButtonRef: menuButtonRef,
      requirement: requirement,
      selectedAction: selectedAction,
      setSelectedAction: setSelectedAction
    })]
  });
}
function MoreActionsConfirmationDialog(_ref7) {
  var menuButtonRef = _ref7.menuButtonRef,
    requirement = _ref7.requirement,
    selectedAction = _ref7.selectedAction,
    setSelectedAction = _ref7.setSelectedAction;
  var _useTranslation5 = useTranslation('ApplicationRequirementCard'),
    t = _useTranslation5.t;
  var _useUpdateApplication2 = useUpdateApplicationRequirement(),
    setNextUpdate = _useUpdateApplication2.setNextUpdate,
    updateStatus = _useUpdateApplication2.updateStatus;
  var toasts = useToasts();
  var text = useMoreActionsMenuDialogText({
    requirement: requirement,
    selectedAction: selectedAction
  });
  if (!text) {
    return null;
  }
  return _jsxs(Dialog, {
    open: !!text,
    onOpenChange: function onOpenChange(newOpen) {
      if (!newOpen) {
        var _menuButtonRef$curren2;
        flushSync(function () {
          setSelectedAction(undefined);
        });
        (_menuButtonRef$curren2 = menuButtonRef.current) === null || _menuButtonRef$curren2 === void 0 ? void 0 : _menuButtonRef$curren2.focus();
      }
    },
    children: [_jsx(Dialog.Heading, {
      children: text.title
    }), _jsx(Dialog.Content, {
      children: _jsx(Text, {
        children: text.info
      })
    }), _jsxs(Dialog.Actions, {
      children: [_jsx(Dialog.CloseButton, {
        width: "fill",
        children: t('cancel')
      }), _jsx(Button, {
        loading: updateStatus === 'loading',
        intent: "primary",
        width: "fill",
        onClick: function onClick() {
          setNextUpdate({
            id: requirement.id,
            type: requirement.type,
            flags: {
              active: selectedAction === 'active' ? !requirement.flags.active : undefined,
              optional: selectedAction === 'optional' ? !requirement.flags.optional : undefined
            }
          }, {
            onSuccess: function onSuccess() {
              var _menuButtonRef$curren3;
              flushSync(function () {
                setSelectedAction(undefined);
              });
              (_menuButtonRef$curren3 = menuButtonRef.current) === null || _menuButtonRef$curren3 === void 0 ? void 0 : _menuButtonRef$curren3.focus();
              toasts.positive(text.success);
            },
            onError: function onError(error) {
              toasts.negative(error);
            }
          });
        },
        children: text.confirm
      })]
    })]
  });
}
function useMoreActionsMenuDialogText(_ref8) {
  var requirement = _ref8.requirement,
    selectedAction = _ref8.selectedAction;
  var _useTranslation6 = useTranslation('ApplicationRequirementCard'),
    t = _useTranslation6.t;
  var action = match(selectedAction)["with"]('active', function () {
    return requirement.flags.active ? 'deactivate' : 'activate';
  })["with"]('optional', function () {
    return requirement.flags.optional ? 'makeRequired' : 'makeOptional';
  })["with"](undefined, function () {
    return undefined;
  }).exhaustive();
  return action ? {
    title: t("".concat(action, ".title")),
    info: t("".concat(action, ".info"), {
      requirementTitle: requirement.title
    }),
    confirm: t("".concat(action, ".confirm")),
    success: t("".concat(action, ".success"), {
      requirementTitle: requirement.title
    })
  } : undefined;
}